import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {GenerateAgencyMagicLinkRequest} from "../../entities/AgencyUser.ts";

export class GenerateAgencyUserMagicLinkUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    // The backend emails this link to the user via Brevo; it's also returned
    // here so the tour operator admin can copy/share it manually as a fallback.
    async execute(agencyId: string, data: GenerateAgencyMagicLinkRequest): Promise<string> {
        const {link} = await this.agencyRepository.generateAgencyUserMagicLink(agencyId, data)
        return link
    }
}
